import { getDefaultState } from '@/store/dialogs/dialogs.utils'

export const DIALOGS = {
  CHECK_ADDRESS: 'checkAddress',
  PRODUCT: 'product',
} as const

export const DIALOGS_STORE_STATE = getDefaultState()
